var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.462 7.40921C13.7883 7.66438 13.846 8.13575 13.5908 8.46203L10.0716 12.962C9.94016 13.13 9.74344 13.2342 9.53062 13.2483C9.3178 13.2625 9.10901 13.1854 8.95649 13.0363L6.47572 10.6112C6.17952 10.3216 6.17414 9.84678 6.46369 9.55059C6.75324 9.25439 7.22809 9.24901 7.52428 9.53856L9.40603 11.3781L12.4092 7.53798C12.6644 7.21169 13.1357 7.15404 13.462 7.40921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckFill);
export default __webpack_public_path__ + "static/media/icon-Check-fill.2586e957a5cfe65ba39ed580931ce641.svg";
export { ForwardRef as ReactComponent };